import { MealCreditPayload } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { sdk } from 'src/utilities/sdk';

export interface AddMealCreditApiProps {
  corpId: string;
  mealCreditPayload: MealCreditPayload;
}

export const addMealCreditApi = async ({
  corpId,
  mealCreditPayload,
}: AddMealCreditApiProps): Promise<{ id: string }> => {
  return sdk.http.post(`/corps/${corpId}/eventmetadata`, mealCreditPayload);
};
